import { render, staticRenderFns } from "./WorkingoutExerciseStatistic.vue?vue&type=template&id=085187da&scoped=true"
import script from "./WorkingoutExerciseStatistic.vue?vue&type=script&lang=js"
export * from "./WorkingoutExerciseStatistic.vue?vue&type=script&lang=js"
import style0 from "./WorkingoutExerciseStatistic.vue?vue&type=style&index=0&id=085187da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085187da",
  null
  
)

export default component.exports